import {
	GoogleMap,
	useJsApiLoader,
	Marker,
	InfoWindowF,
} from "@react-google-maps/api";
import { PolygonF } from "@react-google-maps/api";
import { useState, useEffect, useMemo } from "react";

import beans from "../../../utils/assets/icons/beans2.png";
import soy from "../../../utils/assets/icons/soy.png";
import rice from "../../../utils/assets/icons/rice.png";
import corn from "../../../utils/assets/icons/corn.png";

import styles from "./produtividade.module.css";

import { useTheme, Box, Typography } from "@mui/material";
import { tokens } from '../../../theme'
import MapResumePage from "./map-page-resume";

import Color from 'color';

// const svgMarker = {
// 	path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
// 	fillColor: "blue",
// 	fillOpacity: 0.6,
// 	strokeWeight: 0,
// 	rotation: 0,
// 	scale: 2
// };

const containerStyle = {
	width: "100%",
	height: "100%",
	borderRadius: "8px",
	position: "relative" // Ensures child absolute positioning works
};

const farmNameStyle = {
	position: "absolute",
	bottom: "29px",
	left: "15px",
	zIndex: 1000,
	display: "inline-flex",
	alignItems: "center",
	background: "linear-gradient(135deg, rgba(15,23,42,0.72), rgba(30,41,59,0.52))",
	backdropFilter: "blur(10px)",
	WebkitBackdropFilter: "blur(10px)",
	border: "1px solid rgba(255,255,255,0.14)",
	borderRadius: "16px",
	padding: "10px 16px",
	boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
	maxWidth: "calc(100% - 30px)",
}

const tableStyles = {
	position: "absolute", // Position it over the map
	top: "15px",
	left: "15px",
	backgroundColor: "rgba(255, 255, 255, 0.6)", // White with 70% opacity
	// padding: "20px",
	borderRadius: "8px",
	boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.4)",
	// height: "300px",
	zIndex: 1000, // Ensure it's above the map
	backdropFilter: "blur(10px)" // Optional: Adds a blur effect to the background
};

function parseToDate(value) {
	if (!value) return null;

	if (value instanceof Date) return isNaN(value.getTime()) ? null : value;

	// ISO / timestamp parseável pelo Date
	const d = new Date(value);
	if (!isNaN(d.getTime())) return d;

	// fallback pt-BR dd/mm/yyyy
	const m = String(value).match(/^(\d{2})\/(\d{2})\/(\d{4})/);
	if (m) {
		const dd = Number(m[1]);
		const mm = Number(m[2]) - 1;
		const yyyy = Number(m[3]);
		const d2 = new Date(yyyy, mm, dd);
		return isNaN(d2.getTime()) ? null : d2;
	}

	return null;
}

function calcDAP(dataPlantio) {
	const dt = parseToDate(dataPlantio);
	if (!dt) return null;

	// zera horário para evitar erro de fuso
	const start = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
	const now = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

	const diffDays = Math.floor(
		(today.getTime() - start.getTime()) / 86400000
	);

	// -1 para NÃO contar o dia do plantio
	const dap = diffDays - 1;

	return dap >= 0 ? dap : 0;
}



const MapPage = ({
	mapArray,
	filtData,
	totalSelected,
	setTotalSelected,
	handleSUm,
	printPage,
	showVarOrArea,
	showAsPlanned,
	setShowAsPlanned,
	showResumeMap,
	parcelasSelected,
	toggleParcela,
	useRealArray,
	selectedProject
}) => {
	const formatProjectName = (selectedProject || [])
		.map((proj) => proj.replace(/^Projeto\s+/i, '').trim())
		.join(' | ')
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	const iconDict = [
		{ cultura: "Feijão", icon: beans, alt: "feijao" },
		{ cultura: "Arroz", icon: rice, alt: "arroz" },
		{ cultura: "Soja", icon: soy, alt: "soja" },
		{ cultura: "Milho", icon: corn, alt: "milho" }
	];

	const filteredIcon = (data) => {
		const filtered = iconDict.filter((dictD) => dictD.cultura === data);

		if (filtered.length > 0) {
			return filtered[0].icon;
		}
		return "";
	};

	const filteredAlt = (data) => {
		const filtered = iconDict.filter((dictD) => dictD.cultura === data);

		if (filtered.length > 0) {
			return filtered[0].alt;
		}
		return "";
	};

	const [markerList, setMarkerList] = useState([]);

	const handleClick = (d, e) => {
		// console.log('d map: ', e)
		const djangoId = e.data.data.plantio_id
		// console.log('djamgoID', djangoId)
		// console.log("filtData", filtData)
		const getFIlters = filtData.find((data) => data.id === djangoId)
		// console.log('getFIlters', getFIlters)
		// console.log('getFIlters', getFIlters)
		if (getFIlters) {
			toggleParcela(getFIlters.id_farmbox)
		}
		// setMarkerList((prev) => [
		// 	...prev,
		// 	{ lat: d.latLng.lat(), lng: d.latLng.lng(), data: e }
		// ]);
		// console.log(markerList);
		// handleSUm({
		// 	parcela: e.parcela,
		// 	area: e.data.data.area_colheita
		// });
		// const msg = `${e.parcela} - ${e.data.data.area_colheita.toLocaleString(
		// 	"pt-br",
		// 	{
		// 		minimumFractionDigits: 2,
		// 		maximumFractionDigits: 2
		// 	}
		// )} - ${e.data.data.variedade}`;
	};
	const { isLoaded } = useJsApiLoader({
		id: "google-map-script",
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY
	});

	const [paths, setPaths] = useState([]);
	const [center, setCenter] = useState({});
	const [parcelasApp, setParcelasApp] = useState([]);
	const [appArray, setAppArray] = useState([]);
	const [zoomMap, setZoomMap] = useState();

	const [resumeContainerData, setResumeContainerData] = useState([]);


	// useEffect(() => {
	// 	if (mapArray?.length > 0) {
	// 		if (parcelasSelected.length > 0) {
	// 			const filterSelectedparcelas = filtData.filter((data) => parcelasSelected.includes(data.id_farmbox))
	// 			const onlyFarmId = filterSelectedparcelas.map((data) => data.id)
	// 			const groupedData = Object.values(
	// 				mapArray.filter((data) => onlyFarmId.includes(data.dados.plantio_id)).reduce((acc, curr) => {
	// 					const key = `${curr.dados.cultura}-${curr.dados.variedade}`;
	// 					if (!acc[key]) {
	// 						acc[key] = {
	// 							cultura: curr.dados.cultura,
	// 							variedade: curr.dados.variedade,
	// 							total_area_colheita: 0,
	// 						};
	// 					}
	// 					acc[key].total_area_colheita += curr.dados.area_colheita;
	// 					return acc;
	// 				}, {})
	// 			);
	// 			setResumeContainerData(groupedData)

	// 		} else {

	// 			const groupedData = Object.values(
	// 				mapArray.reduce((acc, curr) => {
	// 					const key = `${curr.dados.cultura}-${curr.dados.variedade}`;
	// 					if (!acc[key]) {
	// 						acc[key] = {
	// 							cultura: curr.dados.cultura,
	// 							variedade: curr.dados.variedade,
	// 							total_area_colheita: 0,
	// 						};
	// 					}
	// 					acc[key].total_area_colheita += curr.dados.area_colheita;
	// 					return acc;
	// 				}, {})
	// 			);
	// 			setResumeContainerData(groupedData)
	// 		}
	// 	}
	// }, [mapArray, parcelasSelected]);

	useEffect(() => {
		if (!mapArray?.length) {
			setResumeContainerData([]);
			return;
		}

		// filtData agora precisa ser a base "ativa" dos novos filtros
		// (cultura / variedade / showAsPlanned), e não mais a base total
		let activeFilterData = Array.isArray(filtData) ? [...filtData] : [];

		// se houver seleção manual de parcelas, restringe ainda mais o resumo
		if (parcelasSelected.length > 0) {
			activeFilterData = activeFilterData.filter((item) =>
				parcelasSelected.includes(item.id_farmbox)
			);
		}

		// se estiver mostrando áreas plantadas, mantém só inicializado_plantio === true
		if (!showAsPlanned) {
			activeFilterData = activeFilterData.filter(
				(item) => item.inicializado_plantio === true
			);
		}

		const activeIds = new Set(activeFilterData.map((item) => item.id));

		const groupedData = Object.values(
			mapArray
				.filter((item) => activeIds.has(item.dados.plantio_id))
				.reduce((acc, curr) => {
					const key = `${curr.dados.cultura}-${curr.dados.variedade}`;

					if (!acc[key]) {
						acc[key] = {
							cultura: curr.dados.cultura,
							variedade: curr.dados.variedade,
							total_area_colheita: 0,
						};
					}

					const semPlanejamento =
						curr.dados.cultura === null &&
						curr.dados.variedade === null;

					const areaPlanejada = Number(
						curr.dados.area_planejamento_plantio
					);

					const areaFisica = Number(
						curr.dados.area_colheita
					);

					const areaToGet = showAsPlanned
						? semPlanejamento
							? (Number.isFinite(areaFisica) ? areaFisica : 0)
							: (Number.isFinite(areaPlanejada) ? areaPlanejada : 0)
						: (Number.isFinite(areaFisica) ? areaFisica : 0);

					acc[key].total_area_colheita += areaToGet;
					return acc;
				}, {})
		);

		setResumeContainerData(groupedData);
	}, [mapArray, filtData, parcelasSelected, showAsPlanned]);





	// const MapOptions = {
	// 	// disableDefaultUI: true
	// 	zoomControl: true,
	// 	mapTypeControl: false,
	// 	scaleControl: true,
	// 	streetViewControl: false,
	// 	rotateControl: true,
	// 	fullscreenControl: true,
	// 	scrollwheel: false,
	// 	zoom: zoomMap,
	// 	mapTypeId: "satellite"
	// }
	const MapOptions = useMemo(() => ({
		// disableDefaultUI: true
		zoomControl: false,
		mapTypeControl: false,
		scaleControl: true,
		streetViewControl: false,
		rotateControl: true,
		fullscreenControl: true,
		scrollwheel: false,
		zoom: zoomMap,
		mapTypeId: "satellite"
	}), [zoomMap])


	useEffect(() => {
		if (filtData) {
			const newArrParcelas = filtData.map(
				(data) => data.talhao__id_talhao
			);
			setParcelasApp(newArrParcelas);
		} else {
			setParcelasApp([]);
		}
	}, [filtData]);

	useEffect(() => {
		if (mapArray.length > 0) {
			const centerId = mapArray[0]?.dados?.projeto_map_centro_id;
			// if (centerId) {
			// 	setCenter(centerId);
			// } else {
			// 	setCenter(
			// 		mapArray[Number(mapArray.length / 2).toFixed(0)]?.dados
			// 			?.map_geo_points[0]
			// 	);
			// }
			const mapZoom = mapArray[0]?.dados?.projeto_map_zoom;
			// console.log(mapZoom)
			if (mapZoom) {
				setZoomMap(mapZoom);
			} else {
				setZoomMap(13.6);
			}
		}
	}, [mapArray]);

	useEffect(() => {
		if (mapArray) {
			let latArr = [];
			let lngArr = [];
			const onlyPaths = mapArray.map((data, i) => {
				// console.log('data check here', data);
				let latLong = [];
				if (data.dados.map_geo_points) {
					latLong = data.dados.map_geo_points.map((data) => {
						latArr.push(Number(data.latitude));
						lngArr.push(Number(data.longitude));
						return {
							lat: Number(data.latitude),
							lng: Number(data.longitude)
						};
					});
				}
				return {
					data: data.dados,
					path: latLong,
					color: "white",
					finalizadoPlantio: data.dados.finalizado_plantio,
					finalizadoColheita: data.dados.finalizado_colheita,
					descontinuado: data.dados.plantio_descontinuado,
					parcela: data.parcela,
					variedadeColor: data.dados.variedade_color,
					variedadeColorLine: data.dados.variedade_color_line
				};
			});
			const getCenterLat = latArr.sort((a, b) => b - a);
			const calCenterlat =
				(getCenterLat[0] + getCenterLat[getCenterLat.length - 1]) / 2;

			const getCenterLng = lngArr.sort((a, b) => b - a);
			const calCenterlng =
				(getCenterLng[0] + getCenterLng[getCenterLng.length - 1]) / 2;
			const centerDict = { lat: calCenterlat, lng: calCenterlng };
			setCenter(centerDict);
			setPaths(onlyPaths);
		}
	}, [mapArray]);

	useEffect(() => {
		const updateColorArray = paths.map((data) => {
			const isActiveFilter = parcelasApp.includes(data.parcela);
			const newColor = isActiveFilter ? data.variedadeColor : "white";

			return {
				data: data,
				finalizadoPlantio: data.finalizadoPlantio,
				finalizadoColheita: data.finalizadoColheita,
				descontinuado: data.descontinuado,
				parcela: data.parcela,
				path: data.path,
				color: newColor,
				variedadeColor: data.variedadeColor,
				variedadeColorLine: data.variedadeColorLine,
				isActiveFilter
			};
		});

		setAppArray(updateColorArray);
	}, [parcelasApp, paths]);

	const getColorStroke = (data) => {
		// console.log('data here:::', data)
		// console.log('data inside', data.variedade)
		const getColor = (variedadeInside, colorInside) => {
			if (variedadeInside === 'Mungo Preto') {
				return '#82202B'
			}
			if (variedadeInside === 'Mungo Verde') {
				return 'rgba(170,88,57,1.0)'
			}
			if (variedadeInside === 'Caupi') {
				return '#3F4B7D'
			}
			// if (variedadeInside?.includes("424")) {
			// 	return '#FFFFCC'
			// }
			if (!variedadeInside) {
				return '#f0f0f0'
			}
			return colorInside
		}
		const getColorLine = (variedadeInside, colorInside) => {
			if (variedadeInside === 'Mungo Preto') {
				return 'rgba(170,88,57,0.7)'
			}
			if (variedadeInside === 'Mungo Verde') {
				return 'rgba(130,32,43,0.7)'
			}
			if (variedadeInside === 'Caupi') {
				return '#3F4B7D'
			}
			// if (variedadeInside?.includes("424")) {
			// 	return '#FFFFCC'
			// }
			if (!variedadeInside) {
				return '#f0f0f0'
			}
			return colorInside
		}

		if (data.isActiveFilter === false) {
			return {
				color: "white",
				stroke: 0.35,
				lineColor: "white",
				lineStroke: 1
			};
		}

		if (showAsPlanned) {
			return {
				color: getColor(data.data.data.variedade, data.variedadeColor),
				stroke: data.data.data.variedade ? 0.8 : 0.3,
				lineColor: getColorLine(data.data.data.variedade, data.variedadeColorLine),
				lineStroke: data.data.data.variedade ? 1.5 : 0.5
			}
		}
		if (
			(data.finalizadoColheita === true &&
				data.finalizadoPlantio === true) ||
			data.data.data.area_planejamento_plantio - data.data.data.area_parcial === 0
		) {
			return {
				color: data.color,
				stroke: 0.4,
				lineColor: data.color,
				lineStroke: 1.5
			};
		}
		if (
			data.data.data.inicializado_plantio === true &&
			data.finalizadoColheita === false &&
			data.descontinuado === false
		) {
			return {
				// color: data.color,
				// stroke: 0.8,
				// lineColor: "yellow",
				// lineStroke: 0.5
				color: getColor(data.data.data.variedade, data.variedadeColor),
				stroke: data.data.data.variedade ? 0.8 : 0.3,
				lineColor: getColorLine(data.data.data.variedade, data.variedadeColorLine),
				lineStroke: data.data.data.variedade ? 1.5 : 0.5
			};
		}

		if (data.descontinuado === true) {
			return {
				color: printPage ? "white" : "red",
				stroke: 0.3,
				lineColor: printPage ? "white" : "red",
				lineStroke: 1
			};
		} else {
			return {
				color: "white",
				stroke: 0.4,
				lineColor: "white",
				lineStroke: 1
			};
		}
	};

	return isLoaded && center ? (
		<div style={{ position: "relative", width: "100%", height: "100%" }}>
			<GoogleMap
				mapContainerStyle={containerStyle}
				center={center}
				options={MapOptions}
				onLoad={(map) => map.setZoom(zoomMap)}
			>
				{appArray &&
					appArray.map((dataF, i) => {
						const area = dataF.data.data.area_colheita.toLocaleString(
							"pt-br",
							{
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}
						);
						const { inicializado_plantio, area_planejamento_plantio, finalizado_plantio, area_colheita } = dataF?.data?.data;
						// const variedade = dataF.data.data.variedade ? dataF.data.data.variedade : '';

						// const variedade = dataF.data.data.cultura === 'Soja' ? dataF.data.data.variedade : '';
						const finalizado =
							dataF.finalizadoPlantio && !dataF.descontinuado;

						// const label = `${dataF.parcela} \n ${showVarOrArea ? area + 'ha' : variedade}`;
						// console.log('dataFFFF: ', dataF)

						const payload = dataF?.data?.data || {};

						const variedade = payload.variedade || "";
						const areaNum = showAsPlanned
							? payload.area_planejamento_plantio
							: payload.area_colheita;

						const areaTxt = Number(areaNum || 0).toLocaleString("pt-br", {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						});

						// data de plantio já validada
						const dataPlantio =
							payload.data_plantio ||
							payload.data_inicio_plantio ||
							payload.plantio_data ||
							null;

						const dap = calcDAP(dataPlantio);

						const naoPlantado = payload.inicializado_plantio !== true;
						// quando plantado: mostra DAP
						// quando não plantado: mostra ícone vermelho
						const statusTxt = naoPlantado ? "💢" : dap !== null ? `${dap} DAP` : "";

						// ===== LABEL =====
						let label = `${dataF.parcela}`;

						if (showVarOrArea) {
							// Linha 2: área
							label += `\n${areaTxt} ha`;

							// Linha 3: variedade ou ícone/status
							if (variedade || statusTxt) {
								label += `\n${[variedade, statusTxt].filter(Boolean).join(" • ")}`;
							}
						} else {
							// Linha 2 e 3
							if (naoPlantado) {
								label += `\n${variedade}\n💢`;
							} else {
								label += `\n${variedade}\n${statusTxt}`;
							}
						}


						// const label = `${dataF.parcela} \n marce`;
						const newLabel = {
							text: finalizado ? label : label,
							color: finalizado ? "white" : "rgba(208,211,212,0.8)",
							className: styles["marker-label"]
						};

						const djangoId = dataF.data.data.plantio_id
						const getFIlters = filtData.find((data) => data.id === djangoId)
						// console.log('getFIlters', getFIlters)
						let isSelected;
						let colorSelected;
						if (getFIlters) {
							const filtered = parcelasSelected.filter((data) => data === getFIlters?.id_farmbox)
							isSelected = filtered.length > 0 ? true : false
							const checkColorSelected = useRealArray.find((data) => data.id_farmbox === getFIlters?.id_farmbox)
							if (checkColorSelected) {
								colorSelected = checkColorSelected.variedadeColor
							}
						} else {
							isSelected = false
						}
						// console.log('data check: ', dataF)
						// console.log("dataArray: ", parcelasSelected)


						const plantioDoing = inicializado_plantio && !finalizado_plantio
						const baseColor = colorSelected || getColorStroke(dataF).color;



						return (
							<>
								<PolygonF
									key={i}
									options={{
										fillColor: plantioDoing
											? Color(baseColor).lighten(0.3).hex() // Pega a cor base, clareia em 30% e converte para string hex
											: baseColor,
										fillOpacity: isSelected ? 0.3 : getColorStroke(dataF).stroke,
										strokeColor:
											isSelected ? "blue" : getColorStroke(dataF).lineColor,
										strokeOpacity: 1,
										strokeWeight: isSelected ? 1 :
											getColorStroke(dataF).lineStroke,
										clickable: true,
										draggable: false,
										editable: false,
										geodesic: false,
										zIndex: 1
									}}
									onClick={(e) => handleClick(e, dataF)}
									// onLoad={onLoad}
									paths={dataF.path}
								/>
								<Marker
									optimized={true}
									label={finalizado ? newLabel : newLabel}
									icon={"."}
									InfoWindowShown={true}
									position={dataF.data.data.map_geo_points_center}
								></Marker>
							</>
						);
					})}

				{markerList &&
					markerList.map((data, i) => {
						// console.log(data.lat, data.lng);
						return (
							<>
								<InfoWindowF
									open={true}
									position={{ lat: data.lat, lng: data.lng }}
									onCloseClick={() => {
										setMarkerList((prev) =>
											prev.filter(
												(dataArray) =>
													dataArray.data.data.data
														.plantio_id !==
													data.data.data.data.plantio_id
											)
										);
										console.log("clic");
									}}
								>
									<div className={styles.popUpMap}>
										<div className={styles.popUpMapInfo}>
											<div>{data.data.parcela}</div>
											<img
												style={{
													width: "15px",
													height: "15px",
													marginRight: "10px"
												}}
												src={filteredIcon(
													data.data.data.data.cultura
												)}
												alt={filteredAlt(
													data.data.data.data.cultura
												)}
											/>
										</div>
										<div className={styles.popUpMapInfoTwo}>
											<div>
												{data.data.data.data.variedade}
											</div>
											<div>
												{data.data.data.data.area_colheita.toLocaleString(
													"pt-br",
													{
														minimumFractionDigits: 2,
														maximumFractionDigits: 2
													}
												)}
											</div>
										</div>
									</div>
								</InfoWindowF>
							</>
						);
					})}
			</GoogleMap>
			{/* Table Container */}
			{showResumeMap &&
				<>
					<Box sx={farmNameStyle}>
						<Typography
							variant="h4"
							fontWeight="bold"
							sx={{
								color: "#fff",
								lineHeight: 1.1,
								textShadow: "0 1px 2px rgba(0,0,0,0.35)",
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
							}}
						>
							{formatProjectName}
						</Typography>
					</Box>
					<Box sx={tableStyles}>
						<MapResumePage data={resumeContainerData} showAsPlanned={showAsPlanned} />
					</Box>
				</>
			}
			<div style={{ position: "absolute", bottom: 90, right: 10, display: "flex", flexDirection: "column", gap: 12, zIndex: 100 }}>
				<button
					onClick={() => setZoomMap((z) => z + 0.4)}
					style={{
						width: 40,
						height: 40,
						lineHeight: "32px",
						textAlign: "center",
						fontSize: 18,
						background: "#fff",
						border: "1px solid #d9d9d9",
						borderRadius: '50%',
						boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
						cursor: "pointer",
						userSelect: "none"
					}}
					onMouseOver={(e) => (e.currentTarget.style.background = "#f5f5f5")}
					onMouseOut={(e) => (e.currentTarget.style.background = "#fff")}
				>
					+
				</button>

				<button
					onClick={() => setZoomMap((z) => z - 0.4)}
					style={{
						width: 40,
						height: 40,
						lineHeight: "32px",
						textAlign: "center",
						fontSize: 18,
						background: "#fff",
						border: "1px solid #d9d9d9",
						borderRadius: '50%',
						boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
						cursor: "pointer",
						userSelect: "none"
					}}
					onMouseOver={(e) => (e.currentTarget.style.background = "#f5f5f5")}
					onMouseOut={(e) => (e.currentTarget.style.background = "#fff")}
				>
					–
				</button>
			</div>
		</div>
	) : (
		<></>
	);
};

export default MapPage;
